import { formatActionText } from 'pages/WellGuardian/WIR/utils';
import {
  FINAL_PREPARATION_ACTION_LABEL,
  WIRCreateJourneyStepsKeys,
  WIRFinalPreparationSectionKey,
  WIRFinalPreparationSections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR, WIRActionStatus } from 'types/wellGuardian';

const getNGFinalPreparationSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRFinalPreparationSections)
        .map(item => ({
          label: WIRFinalPreparationSections[item as WIRFinalPreparationSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.NG_FINAL_PREPARATION,
        }))
        .filter(stepItem =>
          stepItem.label === WIRFinalPreparationSections.updateChemicalPermits ||
          stepItem.label === WIRFinalPreparationSections.wonsApplication ||
          stepItem.label === WIRFinalPreparationSections.hseNotification ||
          stepItem.label === WIRFinalPreparationSections.fpsWaiver ||
          stepItem.label === WIRFinalPreparationSections.bridgingSimopsDocuments ||
          stepItem.label === WIRFinalPreparationSections.perforationProforma ||
          stepItem.label === WIRFinalPreparationSections.vesselApplication ||
          stepItem.label === WIRFinalPreparationSections.iwop ||
          stepItem.label === WIRFinalPreparationSections.simopsDossier ||
          stepItem.label === WIRFinalPreparationSections.vesselSuitabilityInspection
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, FINAL_PREPARATION_ACTION_LABEL) &&
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

const getIrFinalPreparationSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRFinalPreparationSections)
        .map(item => ({
          label: WIRFinalPreparationSections[item as WIRFinalPreparationSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.IRAQ_FINAL_PREPARATION,
        }))
        .filter(stepItem =>
          stepItem.label === WIRFinalPreparationSections.updateChemicalPermits ||
          stepItem.label === WIRFinalPreparationSections.afeApproved ||
          stepItem.label === WIRFinalPreparationSections.regularPermitsRequested ||
          stepItem.label === WIRFinalPreparationSections.partnersNotified ||
          stepItem.label === WIRFinalPreparationSections.hqTechnicalReview ||
          stepItem.label === WIRFinalPreparationSections.wonsApplication ||
          stepItem.label === WIRFinalPreparationSections.hseNotification ||
          stepItem.label === WIRFinalPreparationSections.fpsWaiver ||
          stepItem.label === WIRFinalPreparationSections.bridgingSimopsDocuments ||
          stepItem.label === WIRFinalPreparationSections.perforationProforma ||
          stepItem.label === WIRFinalPreparationSections.vesselApplication ||
          stepItem.label === WIRFinalPreparationSections.iwop ||
          stepItem.label === WIRFinalPreparationSections.simopsDossier ||
          stepItem.label === WIRFinalPreparationSections.vesselSuitabilityInspection
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, FINAL_PREPARATION_ACTION_LABEL) &&
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

const getARFinalPreparationSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRFinalPreparationSections)
        .map(item => ({
          label: WIRFinalPreparationSections[item as WIRFinalPreparationSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.ARGENTINA_FINAL_PREPARATION,
        }))
        .filter(stepItem =>
          stepItem.label === WIRFinalPreparationSections.updateChemicalPermits ||
          stepItem.label === WIRFinalPreparationSections.afeApproved ||
          stepItem.label === WIRFinalPreparationSections.regularPermitsRequested ||
          stepItem.label === WIRFinalPreparationSections.partnersNotified ||
          stepItem.label === WIRFinalPreparationSections.hqTechnicalReview ||
          stepItem.label === WIRFinalPreparationSections.wonsApplication ||
          stepItem.label === WIRFinalPreparationSections.hseNotification ||
          stepItem.label === WIRFinalPreparationSections.fpsWaiver ||
          stepItem.label === WIRFinalPreparationSections.bridgingSimopsDocuments ||
          stepItem.label === WIRFinalPreparationSections.perforationProforma ||
          stepItem.label === WIRFinalPreparationSections.vesselApplication ||
          stepItem.label === WIRFinalPreparationSections.iwop ||
          stepItem.label === WIRFinalPreparationSections.simopsDossier ||
          stepItem.label === WIRFinalPreparationSections.vesselSuitabilityInspection
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, FINAL_PREPARATION_ACTION_LABEL) &&
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

const getCGFinalPreparationSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRFinalPreparationSections)
        .map(item => ({
          label: WIRFinalPreparationSections[item as WIRFinalPreparationSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.CG_FINAL_PREPARATION,
        }))
        .filter(stepItem =>
          stepItem.label === WIRFinalPreparationSections.updateChemicalPermits ||
          stepItem.label === WIRFinalPreparationSections.wonsApplication ||
          stepItem.label === WIRFinalPreparationSections.hseNotification ||
          stepItem.label === WIRFinalPreparationSections.fpsWaiver ||
          stepItem.label === WIRFinalPreparationSections.bridgingSimopsDocuments ||
          stepItem.label === WIRFinalPreparationSections.perforationProforma ||
          stepItem.label === WIRFinalPreparationSections.vesselApplication ||
          stepItem.label === WIRFinalPreparationSections.afeApproved ||
          stepItem.label === WIRFinalPreparationSections.partnersNotified ||
          stepItem.label === WIRFinalPreparationSections.wellInterventionOnPaper ||
          stepItem.label === WIRFinalPreparationSections.equipmentPreparation ||
          stepItem.label === WIRFinalPreparationSections.programmeReview ||
          stepItem.label === WIRFinalPreparationSections.programmeDistributed ||
          stepItem.label === WIRFinalPreparationSections.regularPermitsRequested ||
          stepItem.label === WIRFinalPreparationSections.iwop ||
          stepItem.label === WIRFinalPreparationSections.simopsDossier ||
          stepItem.label === WIRFinalPreparationSections.vesselSuitabilityInspection
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, FINAL_PREPARATION_ACTION_LABEL) &&
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

const getAGFinalPreparationSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRFinalPreparationSections)
        .map(item => ({
          label: WIRFinalPreparationSections[item as WIRFinalPreparationSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.AG_FINAL_PREPARATION,
        }))
        .filter(stepItem =>
          stepItem.label === WIRFinalPreparationSections.updateChemicalPermits ||
          stepItem.label === WIRFinalPreparationSections.wonsApplication ||
          stepItem.label === WIRFinalPreparationSections.hseNotification ||
          stepItem.label === WIRFinalPreparationSections.fpsWaiver ||
          stepItem.label === WIRFinalPreparationSections.bridgingSimopsDocuments ||
          stepItem.label === WIRFinalPreparationSections.perforationProforma ||
          stepItem.label === WIRFinalPreparationSections.vesselApplication ||
          stepItem.label === WIRFinalPreparationSections.afeApproved ||
          stepItem.label === WIRFinalPreparationSections.partnersNotified ||
          stepItem.label === WIRFinalPreparationSections.wellInterventionOnPaper ||
          stepItem.label === WIRFinalPreparationSections.equipmentPreparation ||
          stepItem.label === WIRFinalPreparationSections.programmeReview ||
          stepItem.label === WIRFinalPreparationSections.programmeDistributed ||
          stepItem.label === WIRFinalPreparationSections.regularPermitsRequested
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, FINAL_PREPARATION_ACTION_LABEL) &&
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

export const getFinalPreparationSections = (wir: WIR | null, country: string) => {
  if (country === CountryData.nigeria) {
    return getNGFinalPreparationSections(wir);
  } else if (country === CountryData.iraq) {
    return getIrFinalPreparationSections(wir);
  } else if (country === CountryData.congo) {
    return getCGFinalPreparationSections(wir);
  } else if (country === CountryData.angola) {
    return getAGFinalPreparationSections(wir);
  } else if (country === CountryData.argentina) {
    return getARFinalPreparationSections(wir);
  } else {
    return (
      (wir &&
        Object.keys(WIRFinalPreparationSections)
          .map(item => ({
            label: WIRFinalPreparationSections[item as WIRFinalPreparationSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.FINAL_PREPARATION,
          }))
          .filter(stepItem =>
            stepItem.label === WIRFinalPreparationSections.updateChemicalPermits ||
            stepItem.label === WIRFinalPreparationSections.wonsApplication ||
            stepItem.label === WIRFinalPreparationSections.hseNotification ||
            stepItem.label === WIRFinalPreparationSections.fpsWaiver ||
            stepItem.label === WIRFinalPreparationSections.bridgingSimopsDocuments ||
            stepItem.label === WIRFinalPreparationSections.perforationProforma ||
            stepItem.label === WIRFinalPreparationSections.vesselApplication ||
            stepItem.label === WIRFinalPreparationSections.regularPermitsRequested ||
            stepItem.label === WIRFinalPreparationSections.iwop ||
            stepItem.label === WIRFinalPreparationSections.simopsDossier ||
            stepItem.label === WIRFinalPreparationSections.vesselSuitabilityInspection
              ? wir?.actions?.some(
                  item =>
                    item.actionName ===
                      formatActionText(stepItem.label, FINAL_PREPARATION_ACTION_LABEL) &&
                    item.state !== WIRActionStatus.DELETED,
                )
              : true,
          )) ??
      []
    );
  }
};
